<template>
  <div class="q-pt-md">
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      :filter="filter"
      title="Grupos Já com regra para o CC"
      :rows="rows"
      :columns="columns"
      :loading="disable"
      class="tabela-tamanho-fixo"
      dense
      hide-pagination
    >
      <template v-slot:top-right>
        <q-input
          outlined
          rounded
          dense
          debounce="300"
          v-model="filter"
          placeholder="Buscar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template #body-cell-minimo="props">
        <q-td>
          <div v-if="editarr == props.row.id">
            <q-input dense outlined v-model="props.row.pivot.minimum_days" />
          </div>
          <span v-else>{{ props.row.pivot.minimum_days }}</span>
        </q-td>
      </template>
      <template #body-cell-maximo="props">
        <q-td>
          <div v-if="editarr == props.row.id">
            <q-input dense outlined v-model="props.row.pivot.maximum_days" />
          </div>
          <span v-else>{{ props.row.pivot.maximum_days }}</span>
        </q-td>
      </template>
      <template #body-cell-amount="props">
        <q-td>
          <div v-if="editarr == props.row.id">
            <q-input dense outlined v-model="props.row.pivot.max_amount" />
          </div>
          <span v-else>{{ props.row.pivot.max_amount }}</span>
        </q-td>
      </template>
      <template #body-cell-control="props">
        <q-td style="width: 220px">
          <div v-if="editarr == props.row.id">
            <q-select
              :options="control"
              dense
              outlined
              label="Controle"
              option-label="label"
              option-value="value"
              v-model="props.row.pivot.control_types"
              map-options
            />
          </div>
          <span v-else>
            <span
              v-if="
                props.row.pivot.control_types?.value != '' &&
                props.row.pivot.control_types?.value != undefined
              "
            >
              {{ props.row.pivot.control_types.label }}
            </span>
            <span v-else>
              {{
                props.row.pivot.control_types == "ambos"
                  ? "EMAIL E STATUS TROCA (WEB)"
                  : props.row.pivot.control_types == ""
                  ? "Todos"
                  : props.row.pivot.control_types == "nenhum"
                  ? "NENHUM"
                  : props.row.pivot.control_types == "email"
                  ? "SOMENTE EMAIL"
                  : props.row.pivot.control_types == "farol"
                  ? "SOMENTE STATUS TROCA (WEB)"
                  : ""
              }}
            </span>
          </span>
        </q-td>
      </template>
      <template #body-cell-critico="props">
        <q-td style="width: 180px">
          <div v-if="editarr == props.row.id">
            <q-select
              :options="critico"
              dense
              outlined
              label="Critico"
              option-label="label"
              option-value="value"
              map-options
              v-model="props.row.pivot.critico"
            />
          </div>
          <div v-else>
            <span v-if="props.row.pivot.critico == 0">NÃO</span>
            <span v-else>SIM</span>
          </div>
        </q-td>
      </template>

      <template #body-cell-deletar="props">
        <q-td>
          <q-btn
            @click="deletar(props.row.id)"
            color="negative"
            round
            icon="delete"
            class="q-ml-sm"
          />
        </q-td>
      </template>
    </q-table>
  </div>
</template>

<script>
const columns = [
  {
    name: "code",
    label: "Grupo",
    field: (row) => row.name,
    align: "left",
  },

  {
    name: "minimo",
    label: "Prazo Min.",
    field: (row) => row.pivot.minimum_days,
    align: "left",
  },
  {
    name: "maximo",
    label: "Prazo Máx.",
    field: (row) => row.pivot.maximum_days,
    align: "left",
  },
  {
    name: "amount",
    label: "Quantidade",
    field: (row) => row.pivot.max_amount,
    align: "left",
  },

  {
    name: "deletar",
    label: "Deletar",
    field: "deletar",
    align: "left",
  },
];

import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
export default {
  props: ["atualizar"],
  setup(props) {
    const $q = useQuasar();
    const store = useStore();
    const rows = ref([]);
    const disable = ref(true);
    let filter = ref("");
    const route = useRoute();
    const id = route.params.id;
    const editarr = ref("");
    const regras = ref("");
    const criticoValue = ref("");

    const getCentrosGrupos = async () => {
      let response = await store.dispatch("centroDeCusto/grupoCentros", {
        search: filter.value,
        id: id,
      });

      rows.value = response.data.model.product_group;

      disable.value = false;
    };

    onMounted(getCentrosGrupos);

    const deletar = async (centroId) => {
      try {
        await store.dispatch("centroDeCusto/deletarGrupoRegra", {
          centroId,
          id: id,
        });

        $q.notify({
          message: "Removido com Sucesso ",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getCentrosGrupos();
      } catch (error) {
        $q.notify({
          message: "Erro a o remover",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => filter.value,
      () => {
        getCentrosGrupos();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        getCentrosGrupos();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getCentrosGrupos();
      }
    );

    return {
      columns,
      rows,
      getCentrosGrupos,

      disable,
      filter,

      editarr,
      deletar,
      regras,
      criticoValue,
      control: [
        {
          label: "Todos",
          value: "",
        },
        {
          label: "EMAIL E STATUS TROCA (WEB)",
          value: "ambos",
        },
        {
          label: "NENHUM",
          value: "nenhum",
        },
        {
          label: "SOMENTE EMAIL",
          value: "email",
        },
        {
          label: "SOMENTE STATUS TROCA (WEB)",
          value: "farol",
        },
      ],
      critico: [
        {
          label: "SIM",
          value: 1,
        },
        {
          label: "NÃO",
          value: 0,
        },
      ],
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.circle {
  width: 12px;
  height: 12px;

  border-radius: 50%;
}

.align {
  align-items: center;
}
</style>
